module.exports = __webpack_public_path__ + "img/cancellation.c3c4d23c.png";